<template>
  <AppHeader v-if="$store.getters.isAuth"></AppHeader>
  <router-view></router-view>
  <AppFooter v-if="$store.getters.isAuth"></AppFooter>
</template>

<script>
import $ from "jquery";
import axios from "axios";

import AppHeader from './components/AppHeader.vue';
import AppFooter from './components/AppFooter.vue';

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter
  },
  watch:{
    $route (to, from){
      this.$store.commit("hideAllSidebars");
    }
},
  mounted(){
    
    if(localStorage.getItem("user")){
      //set User Data
      this.$store.commit("setUserData", JSON.parse(localStorage.getItem("user")));  
     
      //set Token
      const userToken = JSON.parse(localStorage.getItem("user")).token;
      axios.defaults.headers.common['Authorization'] = 'Bearer '+userToken;
   
      this.$store.commit("setCategories");
      this.$store.commit("updateExchangeRate");

    }

    if(localStorage.getItem("cart")){
      this.$store.commit("setCartData", JSON.parse(localStorage.getItem("cart")));  
    }

    if(localStorage.getItem("recentlyViewed")){
      this.$store.commit("setRecentlyViewed", JSON.parse(localStorage.getItem("recentlyViewed")));  
    }

    $(window).on("scroll", function () {
    var scrolltop = $(this).scrollTop();

    if (scrolltop >= 1) {
      $("#header").addClass("scroll");
    } else if (scrolltop <= 1) {
      $("#header").removeClass("scroll");
    }
  });
  }
}
</script>

<style>
  @import '@/assets/styles/main.css';
</style>
